import React from 'react';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { ContainedHeader } from 'web-ui-components/lib/layout/headers';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { StatusPanel } from 'web-ui-components/lib/layout/content';
import { SubBody } from 'web-ui-components/lib/typography/body';
import content from './ErrorPage.content';

export const ErrorPage = ({ error }) => (
  <div>
    <ApplicationFormShell header={<ContainedHeader />}>
      <StatusPanel.Error title={content.title}>
        <StandardBody>{content.description}</StandardBody>
        <SubBody>{error}</SubBody>
      </StatusPanel.Error>
    </ApplicationFormShell>
  </div>
);
